import React from 'react';

import Helmet from 'common/helmets/Helmet';

const defaultImage = 'https://canny.io/images/canny-social.png';

interface Props {
  title: string;
  description: string;
  pageUrl: string;
  image?: string;
}

const LandingUseCaseHelmet = ({
  title: baseTitle,
  description,
  image = defaultImage,
  pageUrl,
}: Props) => {
  const title = `${baseTitle} | Canny`;
  return (
    <Helmet
      title={title}
      meta={[
        { name: 'description', content: description },

        { property: 'og:image', content: image },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:url', content: pageUrl },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        { name: 'twitter:image', content: image },
      ]}
    />
  );
};

export default LandingUseCaseHelmet;
